// removed by extract-text-webpack-plugin
module.exports = {"userCommentContainer":"_21aGX0b_JSyyOCQcbrwKqp","userCommnetField":"_3-FAMBYiju53-QTRBFYYJM","removeInput":"d9RmxI1jHQftdgy_yyTJU","cross":"_2lVZlg7mubH5dcmLxgHzx"};


//////////////////
// WEBPACK FOOTER
// ./components/uploader/UploaderTableComment.scss
// module id = 1629
// module chunks = 0